import { PagesEnum } from '~/utils/route-config';

interface LinksWithTo {
    links: Array<{
        to: string;
    }>;
}

/**
 * Removes the HDE link from top-nav and footer link models when market config
 * says the link is unavailable for the current country.
 */
export const removeHDEFromNavLinks = <T extends LinksWithTo>(
    links: T,
    showHDENavLink: boolean,
): T => {
    if (showHDENavLink) {
        return links;
    }

    return filterOutHDELink(links);
};

const filterOutHDELink = <T extends LinksWithTo>(links: T): T => {
    return {
        ...links,
        links: links.links.filter(
            (link) => link.to !== PagesEnum.HOME_DESIGN_EVENING,
        ),
    } as T;
};
